enum NumberEnum {
  float,
  int
}

export default NumberEnum;
